var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_444_32)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0642 14.519C13.3634 12.8622 15 10.4552 15 8.84239C15 6.16801 12.9853 4 10.5 4C8.01472 4 6 6.16801 6 8.84239C6 10.4552 7.63657 12.8622 8.9358 14.519C9.61364 15.3834 9.95256 15.8156 10.5 15.8156C11.0474 15.8156 11.3864 15.3834 12.0642 14.519ZM10.5 10.75C9.56802 10.75 8.8125 9.99448 8.8125 9.0625C8.8125 8.13052 9.56802 7.375 10.5 7.375C11.432 7.375 12.1875 8.13052 12.1875 9.0625C12.1875 9.99448 11.432 10.75 10.5 10.75Z",
    fill: "#6638A2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_444_32"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 12,
    fill: "white",
    transform: "translate(6 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationSmall);
export default __webpack_public_path__ + "static/media/location-small.c8bbe5b6ce893810fc8ebcb582a9c836.svg";
export { ForwardRef as ReactComponent };